/** Talent Hub (marketplace profile) only constants */
export const MARKETPLACE_INNER_ITEM_PADDING = '8px 12px';
